// @ts-check
import request from '@/utils/axios';
import { useEffect, useState } from "react";

/**
 * @typedef StaffProfile
 * @property {string} subject
 * @property {string} name
 * @property {string} emailAddress
 * @property {string} phone
 * @property {string} state
 * @property {string} title
 * @property {string} committee
 * @property {number} personId
 * @property {number} committeeId
 * @property {string} division
 */

/**
 * @typedef {Omit<import("antd/lib/table").ColumnProps<StaffProfile>, 'dataIndex'> & { dataIndex?: keyof StaffProfile }} StaffProfileColumn
 */

/** @param {keyof StaffProfile} type */
export default function useStaffProfiles(type) {
  const [data, setData] = useState(/** @type {StaffProfile[]} */([]));
  const [loading, setLoading] = useState(true);

  const fetchData = async type => {
    /** @type {import("axios").AxiosResponse<{ profiles: StaffProfile[] }>} */
    const { data } = await request({
      url: `profile/staffprofiles`,
      params: { type },
      baseURL: process.env.V2_API_ROOT,
    });
    setData(data.profiles);
    setLoading(false);
  };

  useEffect(() => {
    if (type) fetchData(type);
  }, [type]);

  return { data, loading };
}